import React from "react"
import {Link} from "react-router-dom";
import {ListGroupItem} from "reactstrap";

import Moment from 'react-moment';

export default class DepositEntry extends React.Component {

  componentWillMount() {

  }

  render() {
    const Status = (e) => {
      if (this.props.status == "running")
        return <div className="float-right">Running</div>
      else
        return <div className="float-right">{this.props.status}</div>
    }
    return <ListGroupItem tag={Link} to={"/deposits/"+this.props._id}>{this.props.name} - <small>{this.props.file}</small><Status/></ListGroupItem>
  }
}


// WEBPACK FOOTER //
// ./src/components/Deposits/DepositItem.js